export default {
  data() {
    return {
      currentWave: null,
    };
  },

  computed: {
  },

  methods: {
    calculateCurrentWaveForHealing() {
      const currentDate = new Date(Date.now());
      const currentYear = currentDate.getFullYear();

      const h1HealEnd = new Date(`August 1, ${currentYear} 00:00:00`);
      const h2HealEnd = new Date(`February 1, ${currentYear + 1} 00:00:00`);
      const h2HealEnd2 = new Date(`February 1, ${currentYear} 00:00:00`);
      if(currentDate < h2HealEnd2) {
        this.currentWave = `Q3_Q4_${currentYear - 1}`;
      } else if(currentDate < h1HealEnd) {
        this.currentWave = `Q1_Q2_${currentYear}`;
      } else if(currentDate < h2HealEnd) {
        this.currentWave = `Q3_Q4_${currentYear}`;
      };
    },
    
    openPopup(kpi, wave) {
      if(kpi.SurveyWave.find(x => x.Name == wave)) {
        if (this.selectedKpi == kpi && this.selectedWave == wave) {
          this.hidePopup();
        } else {
          kpi.ShowPopup = true; 
          this.selectedKpi = kpi;
          this.selectedWave = wave;
          this.showPopup = true; 
        } 
      } else {
        this.hidePopup();
      }
    },

    hidePopup() {
      this.selectedKpi = null;
      this.selectedWave = null;
      this.showPopup = false;
    },
  }
};
